export const TRIGGER_OPTIONS = [
  { value: "reservation_checkout", label: "Reservation checkout" },
  { value: "reservation_checkin", label: "Reservation check-in" },
  { value: "reservation_created", label: "Reservation created" },
];

export const SCOPE_OPTIONS = [
  { value: "all_properties", label: "All properties" },
  { value: "properties", label: "Selected properties" },
  { value: "tags", label: "Property tags" },
  { value: "markets", label: "Markets" },
  { value: "zones", label: "Property groups" },
];

export const TASK_TYPE_OPTIONS = [
  { value: "cleaning", label: "Cleaning" },
  { value: "inspection", label: "Inspection" },
  { value: "maintenance", label: "Maintenance" },
  { value: "other", label: "Other" },
];

export const ASSIGNMENT_OPTIONS = [
  { value: "unassigned", label: "Leave unassigned" },
  { value: "specific", label: "Assign everyone selected" },
  { value: "available_pool", label: "Choose one available person" },
];

export const REMINDER_OPTIONS = [
  { value: 0, label: "At task time" },
  { value: 60, label: "1 hour before" },
  { value: 120, label: "2 hours before" },
  { value: 1440, label: "1 day before" },
  { value: 2880, label: "2 days before" },
];

let stepCounter = 0;

export const createTaskStep = (index = 0, values = {}) => {
  stepCounter += 1;
  const taskType = values.task_type || (index === 0 ? "cleaning" : "inspection");
  const name = values.name || (taskType === "cleaning" ? "Clean property" : "Inspect property");
  return {
    id: values.id || `step-${Date.now()}-${stepCounter}`,
    name,
    action_type: "create_task",
    task_type: taskType,
    summary: values.summary || `${name} - {property}`,
    description: values.description || "",
    priority: values.priority || "medium",
    duration_minutes: values.duration_minutes || 60,
    checklist_template_id: values.checklist_template_id || null,
    timing: values.timing || (index === 0
      ? { mode: "reservation_relative", anchor: "checkout", offset_minutes: 0, at_time: "11:00" }
      : { mode: "after_previous", anchor: null, offset_minutes: 0, at_time: "09:00" }),
    assignment: values.assignment || { strategy: "unassigned", assignees: [] },
    reminders: values.reminders || [],
  };
};

export const createStatusStep = () => {
  stepCounter += 1;
  return {
    id: `step-${Date.now()}-${stepCounter}`,
    name: "Mark property ready",
    action_type: "update_property_status",
    property_status: "ready",
    timing: { mode: "after_previous", anchor: null, offset_minutes: 0, at_time: "09:00" },
  };
};

export const createEmptyRule = () => ({
  name: "",
  description: "",
  trigger_type: "reservation_checkout",
  trigger_config: {},
  scope_type: "all_properties",
  scope_values: [],
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
  priority: 100,
  is_active: false,
  definition: {
    steps: [
      createTaskStep(0),
      createTaskStep(1),
    ],
  },
});

export const triggerAnchor = (triggerType) => {
  if (triggerType === "reservation_checkin") return "checkin";
  if (triggerType === "reservation_created") return "created";
  return "checkout";
};

export const normalizeFirstStepTiming = (steps = [], triggerType = "reservation_checkout") => {
  if (!steps.length || steps[0]?.timing?.mode === "fixed") return steps;
  const next = [...steps];
  const first = next[0];
  next[0] = {
    ...first,
    timing: {
      mode: "reservation_relative",
      anchor: triggerAnchor(triggerType),
      offset_minutes: Number(first.timing?.offset_minutes || 0),
      at_time: first.timing?.at_time || "09:00",
      date: null,
    },
  };
  return next;
};

export const optionLabel = (options, value) => (
  options.find((option) => option.value === value)?.label || value
);
